import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { useTranslation } from '@/hooks/useTranslation';
import { MODULE_TEXT, type ModuleAccent } from '@/lib/moduleAccent';
import { cn } from '@/lib/utils';

interface ModuleCardProps {
  titleKey: string;
  descriptionKey: string;
  icon: ReactNode;
  href: string;
  /** Identity colour of the area (theme token). */
  accent: ModuleAccent;
}

export function ModuleCard({ titleKey, descriptionKey, icon, href, accent }: ModuleCardProps) {
  const { t } = useTranslation();

  return (
    <Link to={href} className="block" data-testid="module-card">
      <Card
        padding="sm"
        className="flex h-full flex-col gap-3 transition-all duration-200 hover:border-primary/30 hover:shadow-md"
      >
        <div className={cn('flex items-center gap-2', MODULE_TEXT[accent])}>{icon}</div>
        <div className="flex flex-col gap-1">
          <h3 className="font-semibold text-foreground">{t(titleKey)}</h3>
          <p className="text-sm text-muted-foreground">{t(descriptionKey)}</p>
        </div>
      </Card>
    </Link>
  );
}
